(function () {
  'use strict';

  /*
   * Võti on Zepto algne data-value.
   * Kood muudab ainult kliendile nähtavat teksti.
   */
  const translations = {
    '⚜ Lions': {
      en: '⚜ Lions',
      et: '⚜ Lõvid',
      lv: '⚜ Lauvas',
      lt: '⚜ Liūtai'
    },

    '🐺 Wolves': {
      en: '🐺 Wolves',
      et: '🐺 Hundid',
      lv: '🐺 Vilki',
      lt: '🐺 Vilkai'
    },

    '𝔈𝔖𝔗 Legion': {
      en: '𝔈𝔖𝔗 Legion',
      et: '𝔈𝔖𝔗 Leegion',
      lv: '𝔈𝔖𝔗 Leģions',
      lt: '𝔈𝔖𝔗 Legionas'
    },

    '🇪🇪 Estonia Outline': {
      en: '🇪🇪 Estonia Outline',
      et: '🇪🇪 Eesti kontuur',
      lv: '🇪🇪 Igaunijas kontūra',
      lt: '🇪🇪 Estijos kontūras'
    },

    '〰 Wave': {
      en: '〰 Wave',
      et: '〰 Laine',
      lv: '〰 Vilnis',
      lt: '〰 Banga'
    },

    '🦊 Fox': {
      en: '🦊 Fox',
      et: '🦊 Rebane',
      lv: '🦊 Lapsa',
      lt: '🦊 Lapė'
    },

    '⚔ Fighters': {
      en: '⚔ Fighters',
      et: '⚔ Väike Tõll',
      lv: '⚔ Cīnītāji',
      lt: '⚔ Kovotojai'
    },

    'Ⓜ Monogram': {
      en: 'Ⓜ Monogram',
      et: 'Ⓜ Monogramm',
      lv: 'Ⓜ Monogramma',
      lt: 'Ⓜ Monograma'
    },

    '✷ Zodiac': {
      en: '✷ Zodiac',
      et: '✷ Tähtkujud',
      lv: '✷ Zodiaka zīmes',
      lt: '✷ Zodiako ženklai'
    },
'☀ Tree of Dawn': {
  en: '☀ Tree of Dawn',
  et: '☀ Koidupuu',
  lv: '☀ Austras koks',
  lt: '☀ Aušros medis'
},

    '♈ Jäär / Aries': {
      en: '♈ Aries',
      et: '♈ Jäär',
      lv: '♈ Auns',
      lt: '♈ Avinas'
    },

    '♉ Sõnn / Taurus': {
      en: '♉ Taurus',
      et: '♉ Sõnn',
      lv: '♉ Vērsis',
      lt: '♉ Jautis'
    },

    '♊ Kaksikud / Gemini': {
      en: '♊ Gemini',
      et: '♊ Kaksikud',
      lv: '♊ Dvīņi',
      lt: '♊ Dvyniai'
    },

    '♋ Vähk / Cancer': {
      en: '♋ Cancer',
      et: '♋ Vähk',
      lv: '♋ Vēzis',
      lt: '♋ Vėžys'
    },

    '♌ Lõvi / Leo': {
      en: '♌ Leo',
      et: '♌ Lõvi',
      lv: '♌ Lauva',
      lt: '♌ Liūtas'
    },

    '♍ Neitsi / Virgo': {
      en: '♍ Virgo',
      et: '♍ Neitsi',
      lv: '♍ Jaunava',
      lt: '♍ Mergelė'
    },

    '♎ Kaalud / Libra': {
      en: '♎ Libra',
      et: '♎ Kaalud',
      lv: '♎ Svari',
      lt: '♎ Svarstyklės'
    },

    '♏ Skorpion / Scorpio': {
      en: '♏ Scorpio',
      et: '♏ Skorpion',
      lv: '♏ Skorpions',
      lt: '♏ Skorpionas'
    },

    '♐ Ambur / Sagittarius': {
      en: '♐ Sagittarius',
      et: '♐ Ambur',
      lv: '♐ Strēlnieks',
      lt: '♐ Šaulys'
    },

    '♑ Kaljukits / Capricorn': {
      en: '♑ Capricorn',
      et: '♑ Kaljukits',
      lv: '♑ Mežāzis',
      lt: '♑ Ožiaragis'
    },

    '♒ Veevalaja / Aquarius': {
      en: '♒ Aquarius',
      et: '♒ Veevalaja',
      lv: '♒ Ūdensvīrs',
      lt: '♒ Vandenis'
    },

  '♓ Kalad / Pisces': {
    en: '♓ Pisces',
    et: '♓ Kalad',
    lv: '♓ Zivis',
    lt: '♓ Žuvys'
  },

'With spacing between the letters, you can stretch the text.': {
  en: 'By adding spaces between the letters, you can stretch the text wider.',
  et: 'Tähtede vahele tühikuid pannes saad teksti laiemaks venitada.',
  lv: 'Ievietojot atstarpes starp burtiem, tekstu var izstiept platāku.',
  lt: 'Įterpdami tarpus tarp raidžių, galite ištempti tekstą plačiau.'
},

'Use the -/+ controls to change the text size. Add spaces between the letters to stretch the text.': {
  en: 'Use the -/+ controls to change the text size. Add spaces between the letters to stretch the text.',
  et: '-/+ märkidega saad teksti suurust muuta. Tähtede vahele tühikuid pannes saad teksti laiemaks venitada.',
  lv: 'Ar -/+ pogām vari mainīt teksta izmēru. Ievietojot atstarpes starp burtiem, vari tekstu izstiept platāku.',
  lt: 'Naudodami -/+ mygtukus galite keisti teksto dydį. Įterpdami tarpus tarp raidžių, galite ištempti tekstą plačiau.'
},

'Enter your zodiac sign and/or your name.': {
  en: 'Enter your zodiac sign and/or your name.',
  et: 'Sisesta oma tähtkuju ja/või nimi.',
  lv: 'Ievadi savu zodiaka zīmi un/vai vārdu.',
  lt: 'Įveskite savo zodiako ženklą ir (arba) vardą.'
},

'Use the −/+ controls to change the Monogram size.': {
  en: 'Use the −/+ controls to change the Monogram size.',
  et: 'Monogrammi suuruse muutmiseks kasuta −/+ nuppe.',
  lv: 'Izmanto −/+ pogas, lai mainītu monogrammas izmēru.',
  lt: 'Naudokite −/+ mygtukus monogramos dydžiui pakeisti.'
},

'Text 2': {
  en: 'Text 2',
  et: 'Tekst 2',
  lv: 'Teksts 2',
  lt: 'Tekstas 2'
},

};

  function normalizeText(value) {
    return String(value || '')
      .replace(/[\uFE0E\uFE0F]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getStoreLanguage() {
    const language =
      document.documentElement.getAttribute('lang') || 'en';

    return language.toLowerCase().split('-')[0];
  }

  function translateZeptoOptions() {
    const language = getStoreLanguage();

    document
      .querySelectorAll('.pplr-drop-item[data-value]')
      .forEach(function (option) {
        const originalValue = normalizeText(
          option.getAttribute('data-value')
        );

        const translation = translations[originalValue];

        if (!translation) return;

        const translatedValue =
          translation[language] || translation.en;

        if (
          translatedValue &&
          option.textContent.trim() !== translatedValue
        ) {
          option.textContent = translatedValue;
        }
      });
  }
function translateZeptoPopup() {
  const language = getStoreLanguage();

  const walker = document.createTreeWalker(
    document.body,
    NodeFilter.SHOW_TEXT
  );

  const textNodes = [];
  let node;

  while ((node = walker.nextNode())) {
    textNodes.push(node);
  }

  textNodes.forEach(function (textNode) {
    const parent = textNode.parentElement;

    if (
      !parent ||
      parent.matches('script, style, noscript')
    ) {
      return;
    }

    const originalValue = normalizeText(
      textNode.nodeValue
    );

    const translation = translations[originalValue];

    if (!translation) return;

    const translatedValue =
      translation[language] || translation.en;

    if (
      translatedValue &&
      textNode.nodeValue !== translatedValue
    ) {
      textNode.nodeValue = translatedValue;
    }
  });
}

function initializeLocalization() {
  translateZeptoOptions();
  translateZeptoPopup();

  const observer = new MutationObserver(function () {
    translateZeptoOptions();
    translateZeptoPopup();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initializeLocalization
  );
} else {
  initializeLocalization();
}

document.addEventListener(
  'pplrAppInitiated',
  function () {
    translateZeptoOptions();
    translateZeptoPopup();
  }
);
})();